import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const sellingTerminalsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalList',
      method: 'GET',
      useToken: true,
      title: 'Selling Terminals - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalCreate',
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Selling Terminals - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Selling Terminals - Delete',
      params,
    }),
  addPayment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalAddPayment',
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - Add Payment',
      data,
    }),
  addPaymentPrePaid: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalAddPrePaidPayment',
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - Add Payment Pre Paid',
      data,
    }),
  getWalletHistory: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalWalletHistoryList',
      method: 'GET',
      useToken: true,
      title: 'Selling Terminals - Get Wallet History',
      params,
    }),
  getWalletBalance: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_TERMINAL_WALLET_BALANCE}`,
      method: 'GET',
      useToken: true,
      title: 'Selling Terminals - Get Wallet Balance',
      params,
    }),
  getPayments: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_TERMINAL_PAYMENT}`,
      method: 'GET',
      useToken: true,
      title: 'Selling Reports - Get Payments',
      params,
    }),
  getTransactions: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_TRANSACTION}`,
      method: 'GET',
      useToken: true,
      title: 'Selling Reports - Get Transactions',
      params,
    }),
  getTransactionsResume: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'Selling Reports - Get Transactions Resume',
      params,
    }),
  listTransactionsResume: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_TERMINAL_DAILY_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'Selling Reports - Get Transactions Resume',
      params,
    }),
  payBoleto: ({
    formData,
    transportOperator,
  }: {
    formData: FormData;
    transportOperator: any;
  }) =>
    callAPiBase({
      endpoint: `/sellingTerminalPaymentRequestPayBoleto?transportOperatorId=${transportOperator}`,
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - Pay Boleto',
      formData,
    }),

  dailyReport: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.SELLING_POINT_DAILY_RESUME}`,
      method: 'GET',
      useToken: true,
      title: 'Selling Terminals - Daily Report',
      params,
    }),
  shiftList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingPointShiftList',
      method: 'GET',
      useToken: true,
      title: 'Selling Points - Get List',
      params,
    }),

  ticketCountList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalPlaceList',
      method: 'GET',
      useToken: true,
      title: 'Selling Terminals - TicketCountList',
      params,
    }),

  ticketCountCreate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalPlaceCreate',
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - TicketCountCreate',
      data,
    }),
  ticketCountUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalPlaceUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Selling Terminals - TicketCountUpdate',
      data,
    }),
  ticketCountDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingTerminalPlaceDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Selling Terminals - TicketCountDelete',
      params,
    }),

  shiftScheduleList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingPointShiftScheduleList',
      method: 'GET',
      useToken: true,
      title: 'Selling Terminals - sellingPointShiftScheduleList',
      params,
    }),

  shiftScheduleCreate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointShiftScheduleCreate',
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - sellingPointShiftScheduleCreate',
      data,
    }),
  shiftScheduleUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointShiftScheduleUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Selling Terminals - sellingPointShiftScheduleUpdate',
      data,
    }),
  shiftScheduleDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sellingPointShiftScheduleDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Selling Terminals - sellingPointShiftScheduleDelete',
      params,
    }),

  shiftScheduleRun: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sellingPointShiftScheduleRun',
      method: 'POST',
      useToken: true,
      title: 'Selling Terminals - shiftScheduleRun',
      data,
    }),
};

export { sellingTerminalsApi };
export default sellingTerminalsApi;
